export default __webpack_public_path__ + "7820aceb12ecb86686ac36d5690f3c4b.png";